import styled from 'styled-components';

export default styled.div`
  height: 131px;

  .input-group {
    height: 100%;
    display: grid;
    align-items: center;

    &.goal {
      grid-template-columns: 1fr 1fr auto;

      #indirect-assist-checkbox,
      #own-goal-checkbox {
        margin-top: 18px;
      }

      .section {
        display: grid;
        grid-template-columns: auto auto;
        grid-gap: 10px;
        justify-content: center;
        align-items: center;
      }
    }

    &.substitution {
      grid-template-columns: auto auto auto;
      justify-content: center;
      align-items: center;
      grid-gap: 22px;

      img {
        width: 25px;
        height: 25px;
        margin-top: 20px;
      }
    }

    &.penalty {
      .inputLinePenalties {
        grid-template-columns: 1fr !important;
      }
      .inputsLine {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        justify-content: center;
        align-items: center;
        grid-gap: 22px;
      }
      .buttonsLinePenalties {
        grid-template-columns: 1fr 1fr 1fr !important;
      }
      .buttonsLine {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        justify-content: center;
        align-items: center;
        grid-gap: 22px;
        button {
          margin: auto;
        }
      }
    }

    &.penalty-miss {
      .inputsLine {
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: center;
        align-items: center;
        grid-gap: 22px;
      }
      .noKeeperInput {
        grid-template-columns: 1fr;
      }
    }

    &.penalties-goal {
      .inputsLine {
        display: grid;
        grid-template-columns: 1fr;
        justify-content: center;
        align-items: center;
      }
    }

    .checkbox {
      grid-column: 2;
      align-self: center;
      justify-self: center;
    }
  }
`;
